import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Footer from '../components/footer';
import backgroundImage from '../assets/background.png';
import '../css/pages_styles.css';

const WASN_Poster = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [sidebarExpanded, setSidebarExpanded] = useState(true);

    // 偵測螢幕大小
    useEffect(() => {
        const checkScreenSize = () => {
            const width = window.innerWidth;
            setIsMobile(width <= 768);
        };

        // 初始檢查
        checkScreenSize();

        // 監聽視窗大小變化
        window.addEventListener('resize', checkScreenSize);
        
        // 清理事件監聽器
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    // 監聽 sidebar 狀態變化的函數
    const handleSidebarToggle = (isExpanded) => {
        setSidebarExpanded(isExpanded);
    };

    // 第一場次 WASN 海報資料 - 2025/08/25 10:00-10:50
    const session1WASNData = [
        { posterNum: 11, wasnId: 28, title: "Application of Zero-Knowledge Proof and Consortium Blockchain Architecture for a Semi-Transparent Business Card and Voting System" },
        { posterNum: 12, wasnId: 29, title: "基於CoMP機制之NOMA通訊之非完美連續干擾消除之效能" },
        { posterNum: 13, wasnId: 30, title: "在聯邦學習下以生成對抗網路強化模型間即時物件偵測之知識分享" },
        { posterNum: 14, wasnId: 31, title: "Deep Pet Comforting and Feeding with Anomaly Symptom Determination Based on the Internet of Things" },
        { posterNum: 15, wasnId: 34, title: "基於AIoT之視力檢測系統" },
        { posterNum: 16, wasnId: 36, title: "運用知識蒸餾技術於交通場景感測融合物體偵測之研究" },
        { posterNum: 17, wasnId: 40, title: "Fusion of Thoughts: Enhancing Tree and Graph-Based Prompting via Thought Merging" },
        { posterNum: 18, wasnId: 46, title: "藍牙RSSI導引之低延遲智慧推車系統設計" },
        { posterNum: 19, wasnId: 50, title: "Joint Age of Information and Energy Optimization in Multi-RSU C-V2X Networks" }
    ];

    // 第二場次 WASN 海報資料 - 2025/08/25 15:20-16:10
    const session2WASNData = [
        { posterNum: 16, wasnId: 41, title: "智慧居家控制與多媒體生成系統" },
        { posterNum: 17, wasnId: 3, title: "基於5G物聯網與近端策略優化的疲勞駕駛偵測系統" },
        { posterNum: 18, wasnId: 5, title: "基於重播方式用於自適應學習之聯邦持續學習" },
        { posterNum: 19, wasnId: 10, title: "機器學習於糖尿病風險預測之多模型比較與應用" }
    ];

    // 第三場次 WASN 海報資料 - 2025/08/26 09:30-10:20
    const session3WASNData = [
        { posterNum: 7, wasnId: 52, title: "一種基於模型分離式協同訓練的新型聯邦學習架構" },
        { posterNum: 8, wasnId: 53, title: "Kube5GC: Kubernetes-Native Orchestration for 5G Core Network" },
        { posterNum: 9, wasnId: 62, title: "一種針對分散式標籤情境下具隱私保護的垂直式聯邦學習方案設計" },
        { posterNum: 10, wasnId: 66, title: "基於充電時間差校正法與具截止時間之旅行推銷員問題模型的無人機感測節點充電與定位策略" },
        { posterNum: 11, wasnId: 71, title: "利用無人機解決不規則區域中強化式防禦線突破問題之研究" }
    ];

    // 第四場次 WASN 海報資料 - 2025/08/26 10:30-11:20
    const session4WASNData = [
        { posterNum: 7, wasnId: 51, title: "針對KKT最佳化模型訓練資料重建攻擊的反制策略探討" },
        { posterNum: 8, wasnId: 73, title: "Toward Interpretable Multimodal Violence Detection With Knowledge Distillation and Modality-Aligned Preprocessing" },
        { posterNum: 9, wasnId: 75, title: "無線可充電感測器網路中的多台行動充電器高效協作" },
        { posterNum: 10, wasnId: 77, title: "CLIP-LwF：一種基於 CLIP 與 知識蒸餾的類別增量學習策略設計" },
        { posterNum: 11, wasnId: 80, title: "Development and Implementation of Cloud-Based Identification Platform for Taiwanese Freshwater Fish Using Deep Learning Image Recognition Techniques" }
    ];

    return (
        <div style={{ display: 'flex', position: 'relative' }}>
            <Sidebar onToggle={handleSidebarToggle} />
            <div 
                className="main-content"
                style={{
                    marginLeft: isMobile ? '0' : (sidebarExpanded ? '250px' : '0')
                }}
            >
                <div className="container">
                    <header 
                        className="header"
                        style={{backgroundImage: `url(${backgroundImage})`}}
                        >
                        <h1 className="title">WASN海報編號</h1>
                    </header>

                    {/* 第一場次 */}
                    <section className={`section ${isMobile ? 'section-mobile' : ''}`}>
                        <div className="subtitle">
                            <strong>Poster 論文研究成果發表 I (亞歷山大廳)</strong>
                        </div>
                        <div style={{ 
                            fontSize: '1em', 
                            color: '#666', 
                            marginBottom: '20px',
                            textAlign: 'center'
                        }}>
                            時間：10:00-10:50 | 日期：2025/08/25
                        </div>
                        
                        <div className="table-container">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className="th" style={{ width: '100px' }}>海報編號</th>
                                        <th className="th" style={{ width: '80px' }}>WASN - ID</th>
                                        <th className="th">論文標題</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {session1WASNData.map((item, index) => (
                                        <tr key={index}>
                                            <td className="td" style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                Post {item.posterNum}
                                            </td>
                                            <td className="td" style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                WASN - {item.wasnId}
                                            </td>
                                            <td className="td" style={{ textAlign: 'left', padding: '12px 15px' }}>
                                                {item.title}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </section>

                    {/* 第二場次 */}
                    <section className={`section ${isMobile ? 'section-mobile' : ''}`}>
                        <div className="subtitle">
                            <strong>Poster 論文研究成果發表 II (亞歷山大廳)</strong>
                        </div>
                        <div style={{ 
                            fontSize: '1em', 
                            color: '#666', 
                            marginBottom: '20px',
                            textAlign: 'center'
                        }}>
                            時間：15:20-16:10 | 日期：2025/08/25
                        </div>
                        
                        <div className="table-container">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className="th" style={{ width: '100px' }}>海報編號</th>
                                        <th className="th" style={{ width: '80px' }}>WASN - ID</th>
                                        <th className="th">論文標題</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {session2WASNData.map((item, index) => (
                                        <tr key={index}>
                                            <td className="td" style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                Post {item.posterNum}
                                            </td>
                                            <td className="td" style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                WASN - {item.wasnId}
                                            </td>
                                            <td className="td" style={{ textAlign: 'left', padding: '12px 15px' }}>
                                                {item.title}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </section>

                    {/* 第三場次 */}
                    <section className={`section ${isMobile ? 'section-mobile' : ''}`}>
                        <div className="subtitle">
                            <strong>Poster 論文研究成果發表 III (亞歷山大廳)</strong>
                        </div>
                        <div style={{ 
                            fontSize: '1em', 
                            color: '#666', 
                            marginBottom: '20px',
                            textAlign: 'center'
                        }}>
                            時間：09:30-10:20 | 日期：2025/08/26
                        </div>
                        
                        <div className="table-container">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className="th" style={{ width: '100px' }}>海報編號</th>
                                        <th className="th" style={{ width: '80px' }}>WASN - ID</th>
                                        <th className="th">論文標題</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {session3WASNData.map((item, index) => (
                                        <tr key={index}>
                                            <td className="td" style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                Post {item.posterNum}
                                            </td>
                                            <td className="td" style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                WASN - {item.wasnId}
                                            </td>
                                            <td className="td" style={{ textAlign: 'left', padding: '12px 15px' }}>
                                                {item.title}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </section>

                    {/* 第四場次 */}
                    <section className={`section ${isMobile ? 'section-mobile' : ''}`}>
                        <div className="subtitle">
                            <strong>Poster 論文研究成果發表 IV (亞歷山大廳)</strong>
                        </div>
                        <div style={{ 
                            fontSize: '1em', 
                            color: '#666', 
                            marginBottom: '20px',
                            textAlign: 'center'
                        }}>
                            時間：10:30-11:20 | 日期：2025/08/26
                        </div>
                        
                        <div className="table-container">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className="th" style={{ width: '100px' }}>海報編號</th>
                                        <th className="th" style={{ width: '80px' }}>WASN - ID</th>
                                        <th className="th">論文標題</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {session4WASNData.map((item, index) => (
                                        <tr key={index}>
                                            <td className="td" style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                Post {item.posterNum}
                                            </td>
                                            <td className="td" style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                                WASN - {item.wasnId}
                                            </td>
                                            <td className="td" style={{ textAlign: 'left', padding: '12px 15px' }}>
                                                {item.title}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </section>

                    <Footer/>
                </div>
            </div>
        </div>
    );
};

export default WASN_Poster;